import router from '../router'
import { bus } from '../main'

export default {
  namespaced: true,
  state: {
    isOverridingBackground: false,
    showAssetTag: {},
    showAssetSource: '',
    showAssetvirtualTourUrl: '',

    showIssuuUrl: '',
  },
  
  getters: {
    isShowingAssetViewer (state) {
      return state.showAssetSource ? true : false
    }
  },

  actions: {
    TRIGGER_CHANGE_BACKGROUND ({commit, state, rootState, rootGetters}, {payload, icon}) {
      state.isOverridingBackground = !state.isOverridingBackground

      if (state.isOverridingBackground) {
        commit('SET_ACTIVE_BACKGROUND_OVERRIDE', payload, { root: true })
      } else {
        commit('SET_ACTIVE_BACKGROUND_OVERRIDE', '', { root: true })
      }

      setTimeout(() => {
        bus.$emit('startAnimations')
      }, 500)
    },

    TRIGGER_NAV_ROUTER ({rootState}, { payload }) {
      const categoryId = rootState.route.params.categoryId
      router.push(`/category/${categoryId}/page/${payload}`)
    },

    TRIGGER_SHOW_ASSET ({commit}, {payload, tag, virtualTourUrl}) {
      commit('SET_SHOW_ASSET_PAYLOAD', {payload, tag, virtualTourUrl})
    },
  },

  mutations: {
    SET_SHOW_ASSET_PAYLOAD (state, {payload, tag, virtualTourUrl}) {
      state.showAssetTag = tag
      state.showAssetSource = payload
      state.showAssetvirtualTourUrl = virtualTourUrl
    },

    SET_ISSUU_URL (state, url) {
      state.showIssuuUrl = url
    },
  },
}
